import api from '..'

const AllfoldersList = () => {
    return api.get('/courses/allfolders').then(({ data }) => {
        return {
            dataAll: data.data.map(({ attributes }: any) => attributes),
        }
    })
}

export default AllfoldersList
